import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      user: this.$store.state.user,
      key: 0,
      name: "",
      rights: [],
      roles: [],
      right: "",
      value: "",
      message: "",
      response: [],
      openCategories: [],
      categories: [],
      subcategories: [],
      stateCategory: "category",
      error: false,
      categoryRight: 0,
      expanded: false,
      spaces: [],
      spaceRight: 0,
      titleToIcon: {
        spaces: "space",
        folders: "folder",
        files: "file--simple",
        tags: "tag",
        faces: "user",
        notifications: "notify",
        "copy/paste": "copy",
        admin: "gear",
        users: "users",
        roles: "users",
        branding: "branding",
        collect: "collect",
        transfer: "transfer",
        "quick transfer": "transfer",
        "my space": "myspace",
      },
      toolTipText: {
        spaces: i18n.t("tooltip.space"),
        folders: i18n.t("tooltip.folders"),
        files: i18n.t("tooltip.files"),
        tags: i18n.t("tooltip.tags"),
        faces: i18n.t("tooltip.faces"),
        notifications: i18n.t("tooltip.notifications"),
        "copy/paste": i18n.t("tooltip.copy_paste"),
        admin: i18n.t("tooltip.admin"),
        users: i18n.t("tooltip.users"),
        roles: i18n.t("tooltip.roles"),
        branding: i18n.t("tooltip.branding"),
        collect: i18n.t("tooltip.collect"),
        transfer: i18n.t("tooltip.transfer"),
        "quick transfer": i18n.t("tooltip.quick_transfer"),
        "my space": i18n.t("tooltip.my_space"),
      },
    };
  },
  created() {
    this.getRoles();

    this.$axios.get(baseUrl + "/rights").then((response) => {
      this.rights = response.data;
      this.setCategories(this.rights);
    });
    this.$axios
      .get(baseUrl + "/roots", {
        responseType: "json",
      })
      .then((r) => {
        this.spaces = r.data;
      });
  },
  methods: {
    setDesc(title) {
      return this.toolTipText[title];
    },
    /**
     * Get the existing roles
     */
    getRoles() {
      this.$axios.get(baseUrl + "/companyroles").then((response) => {
        let $items = response.data;
        for (let $item in $items) {
          let $role = $items[$item].name.toLowerCase();
          this.roles.push($role);
        }
      });
    },
    /**
     * Show next
     */
    showNext() {
      // check if the user role exists
      if (this.key == 0) {
        let $role = this.name.toLowerCase();
        let found = this.roles.includes($role);

        if (!found) {
          this.key++;
        } else {
          this.error = true;
          this.message =
            "Uh-oh! There’s already a role with that name that manages your herd. Please add a different name.";
        }
      } else {
        this.key++;
      }
    },
    removeError() {
      this.error = false;
      this.message = "";
    },
    /**
     * Set the rights categories
     * @param rights
     */
    setCategories: function (rights) {
      this.categories = [];

      for (let right in rights) {
        let category = [];
        let subCategory = [];
        let title;

        // set the category title
        if (right.includes("_")) {
          title = right.split("_")[1];
          title = this.getTitle(title);
          this.findCategory(title);

          if (this.stateCategory === "category") {
            category.title = title;
            category.value = 1;
            if (title === "files") {
              category.active = false;
              category.rights = [];
              category.subcategories = [];
              this.categories.push(category);
              if (this.name.toLowerCase() != "public") {
                let adminObj = [];
                adminObj.title = "admin";
                adminObj.value = 1;
                adminObj.active = false;
                adminObj.subcategories = [];
                this.categories.push(adminObj);
              }
            } else {
              category.active = false;
              category.rights = [];
              this.categories.push(category);
            }
          }

          if (this.stateCategory === "subCategory") {
            subCategory.title = title;
            if (
              title === "tags" ||
              title === "faces" ||
              title === "notifications"
            ) {
              subCategory.parent = "files";
            } else {
              subCategory.parent = "admin";
            }
            this.subcategories.push(subCategory);
          }
        } else {
          title = right;
          title = this.getTitle(title);
          category.title = title;
          category.value = this.rights[right];
          category.right = right;
          this.categories.push(category);
        }
      }

      for (let category in this.categories) {
        let found = false;
        if (this.categories[category].rights) {
          let title;
          let categoryRight = [];
          for (let right in rights) {
            let item = [];
            if (right.includes(this.categories[category].title)) {
              title = right.split("_")[0];
              item.title = this.getTitle(title);
              item.value = this.rights[right];
              item.right = right;
              categoryRight.push(item);

              if (this.rights[right] == 0) {
                found = true;
              }
            }
          }
          this.categories[category].rights = categoryRight;
        }

        if (this.categories[category].subcategories) {
          if (this.categories[category].title === "files") {
            let subCategories = [];
            let item = [];
            let rights_array = [];
            let title;

            title = "tags";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            item = [];
            rights_array = [];
            title = "faces";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            item = [];
            rights_array = [];
            title = "notifications";
            item.title = "notifications";
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            this.categories[category].subcategories = subCategories;
          }

          if (this.categories[category].title === "admin") {
            let subCategories = [];
            let item = [];
            let rights_array = [];
            let title;

            title = "users";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            item = [];
            rights_array = [];
            title = "roles";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            item = [];
            rights_array = [];
            title = "branding";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            this.categories[category].subcategories = subCategories;
          }
        }

        if (found) {
          this.categories[category].value = 0;
        }
      }
    },
    /**
     * Get the rights
     *
     * @param title
     * @param rights
     * @returns {Array}
     */
    getRights(title, rights) {
      let items = [];
      for (let right in rights) {
        let item = [];
        if (right.includes(title)) {
          let rightTitle = right.split("_")[0];
          item.title = this.getTitle(rightTitle);
          item.value = this.rights[right];
          item.right = right;
          items.push(item);
        }
      }
      return items;
    },
    /**
     * Get the title in the right format
     *
     * @param title
     * @returns {*}
     */
    getTitle(title) {
      if (title.includes("-")) {
        title = title.replace("-", " ");
      }

      if (title.includes("+")) {
        title = title.replace("+", "/");
      }
      return title;
    },
    /**
     * Check if it is a category
     *
     * @param title
     */
    findCategory(title) {
      this.stateCategory = "category";
      if (
        title === "tags" ||
        title === "faces" ||
        title === "notifications" ||
        title === "users" ||
        title === "roles" ||
        title === "branding"
      ) {
        this.stateCategory = "subCategory";
      } else {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i].title === title) {
            this.stateCategory = "found";
            break;
          }
        }
      }
    },
    /**
     * Update the right
     *
     * @param right
     * @param value
     */
    updateRight(right, value) {
      if (value === 0) {
        this.$set(this.rights, right, 1);
        this.setCategories(this.rights);
      }
      if (value === 1) {
        this.$set(this.rights, right, 0);
        this.setCategories(this.rights);
      }
    },
    /**
     * Submit the new role
     */
    submit() {
      const formData = new FormData();
      let blockedList = "";

      Object.keys(this.spaces).forEach((key) => {
        const item = this.spaces[key];
        blockedList += item.id + "," + item.checked + ";";
      });

      formData.append("name", this.name);
      formData.append("rights", JSON.stringify(this.rights));
      formData.append("blockedList", blockedList);

      this.$axios.post(baseUrl + "/addrole", formData).then((response) => {
        if (response.data) {
          let id = response.data.id;
          let name = response.data.name;

          this.key = 3;

          setTimeout(function () {
            EventBus.$emit("open-users-by-role", { id, name });
            EventBus.$emit("get-all-roles");
          }, 100);
        }
      });
    },
    /**
     * Close the users by role overview
     */
    close() {
      EventBus.$emit("close-manage-user-actions");
    },
    setIcon(title) {
      return this.titleToIcon[title] ? this.titleToIcon[title] : "space";
    },
    /**
     * Open
     *
     * @param title
     */
    setOpen(title) {
      if (this.openCategories.length === 0) {
        this.openCategories.push(title);
      } else {
        if (this.openCategories.includes(title)) {
          this.openCategories = this.openCategories.filter(function (el) {
            return el !== title;
          });
        } else {
          this.openCategories.push(title);
        }
      }
    },
    /**
     * Expand or collapse all the categories
     */
    setExpanded() {
      if (this.expanded) {
        this.expanded = false;

        this.openCategories = [];
      } else {
        this.expanded = true;
        for (let category in this.categories) {
          let title = this.categories[category].title;
          if (!this.openCategories.includes(title)) {
            this.openCategories.push(title);
          }
        }
      }
    },
    /**
     * Check category to check all
     * @param title
     * @param value
     */
    checkCategory(title, value) {
      if (value == 0) {
        for (let category in this.categories) {
          let parent = this.categories[category];
          if (parent.title == title) {
            for (let item in parent.rights) {
              let right = parent.rights[item].right;
              this.$set(this.rights, right, 1);
            }
            for (let item in parent.subcategories) {
              for (let sub in parent.subcategories[item]) {
                let subcategory = parent.subcategories[item][sub];
                for (let right in subcategory) {
                  if (subcategory[right].right != undefined) {
                    this.$set(this.rights, subcategory[right].right, 1);
                  }
                }
              }
            }
            this.setCategories(this.rights);
          }
        }
      } else {
        for (let category in this.categories) {
          let parent = this.categories[category];
          if (parent.title == title) {
            for (let item in parent.rights) {
              let right = parent.rights[item].right;
              this.$set(this.rights, right, 0);
            }

            for (let item in parent.subcategories) {
              for (let sub in parent.subcategories[item]) {
                let subcategory = parent.subcategories[item][sub];
                for (let right in subcategory) {
                  if (subcategory[right].right != undefined) {
                    this.$set(this.rights, subcategory[right].right, 0);
                  }
                }
              }
            }
            this.setCategories(this.rights);
          }
        }
      }
    },
    checkSpace(id, checked) {
      let data = this.spaces[id];
      data.checked = checked === 1 ? 0 : 1;
      this.$set(this.spaces, id, data);
    },
  },
};
